module.exports = __webpack_public_path__ + "img/gas.2c051e76.svg";